import { queryOptions } from '@tanstack/react-query';

import { api } from '@/lib/api/api';
import type { GeneralAgentListParams } from '@/lib/api/domains/general-agents';
import type { GeneralAgentId } from '@/lib/api/ids';
import { keys } from '@/lib/query-keys';

/** Consumption layer for general agents (mirrors providers'/clients' shape). */
export function generalAgentListQuery(params: GeneralAgentListParams) {
  return queryOptions({
    queryKey: keys.generalAgents.list(params),
    queryFn: () => api.generalAgents.list(params),
    staleTime: 30_000,
  });
}

export function generalAgentDetailQuery(generalAgentId: GeneralAgentId) {
  return queryOptions({
    queryKey: keys.generalAgents.detail(generalAgentId),
    queryFn: () => api.generalAgents.get(generalAgentId),
    staleTime: 30_000,
  });
}
